import React from "react";
import { Route, Routes } from "react-router-dom";
import Roles from "../inner_pages/roles/Roles";
import User from "../inner_pages/user/User";


const User_Management_Routes = () => {
  return (
    <Routes>
      <Route path="/roles" element={<Roles />} />
      <Route path="/user" element={<User />} />
    </Routes>
  );
};

export default User_Management_Routes;
